import React from 'react';

// Icons
import { CircleCheck, InfoOutline } from 'assets/images';

// Constant
import { COMPLETE, ERROR } from 'constants/createEmployeeForm';

/**
 @state
* Complete
* Selected --
* Hovered
* Error
 **/

interface StepperItem {
  id: number;
  label: string;
  detail: string;
  state?: string;
}

interface StepperNavigationProps {
  item: StepperItem;
  onNavigate: (id: number) => void;
  currentForm: StepperItem;
}

const StepperNavigation: React.FC<StepperNavigationProps> = (props) => {
  const { item, onNavigate, currentForm } = props;

  return (
    <div
      onClick={() => onNavigate(item.id)}
      className={`steppernavigation ${
        item.state === COMPLETE ? 'steppernavigation--complete' : item.state === ERROR ? 'steppernavigation--error' : ''
      } ${item.id === currentForm.id ? 'steppernavigation--selected' : ''}`}
    >
      <div className="steppernavigation__icon">
        {item.state === COMPLETE ? (
          <img src={CircleCheck} alt="CircleCheck" srcSet="" />
        ) : item.state === ERROR ? (
          <img src={InfoOutline} alt="Infooutline" srcSet="" />
        ) : (
          <p className="steppernavigation__icon__id">{item.id}</p>
        )}
      </div>
      <div className="steppernavigation__box">
        <p className="title">{item.label}</p>
        <p className="detail">{item.detail}</p>
      </div>
    </div>
  );
};

export default StepperNavigation;
